export function FaIcon({ name, className }: { name: string; className?: string }) {
  return <img src={`/icons/${name}.svg`} alt="" className={className} />;
}
